/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Unexpected_ErrorInputs */

const en_common_unexpected_error = /** @type {(inputs: Common_Unexpected_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again.`)
};

const pt_br2_common_unexpected_error = /** @type {(inputs: Common_Unexpected_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro inesperado. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Please try again." |
*
* @param {Common_Unexpected_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const common_unexpected_error = /** @type {((inputs?: Common_Unexpected_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Unexpected_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_unexpected_error(inputs)
	return pt_br2_common_unexpected_error(inputs)
});